import { useEffect, useState } from "react";
import { Option } from "..";
import DropdownWithValidation from "./DropdownWithValidation";
import { BlogService } from "../../../services";

export interface AuthorPickerProps {
  id: string;
  label: string;
  onSelect: (value: string) => void;
  initialValue?: string;
}

export function AuthorPicker(props: Readonly<AuthorPickerProps>) {
  const [options, setOptions] = useState<Option[]>([]);

  useEffect(() => {
    const fetchAuthors = async () => {
      try {
        let authorList: { value: string, text: string }[] = [{ value: "", text: "Select Author" }];
        const data = await new BlogService().getBlogAuthorsAsync();
        if (!data) return;
        data.value.forEach((blog) => {
          const map = new Map(Object.entries(blog));
          const id = map.get("id");
          const name = map.get("displayName");
          let blogInfo = { value: id, text: name };
          authorList.push(blogInfo);
        });
        setOptions(authorList);
      } catch (e) {
        console.error("Error loading blogs", e);
      }
    };

    fetchAuthors();
  }, []);

  return (
    <DropdownWithValidation
      required={true}
      id={props.id}
      label={props.label}
      options={options}
      initialValue={props.initialValue}
      onChangeSelected={(value: React.SetStateAction<string>) => {
        props.onSelect(value.toString());
      }}
    />
  );
}

export default AuthorPicker;
